import { defaultState } from './defaultState';
import { researchersReducers } from './researchers';
import { workItemsReducers } from './workItems';
import { clinicalTrialsReducers } from './clinicalTrials';
import { tradeshowsReducers } from './tradeshows';
import { purchasingReducers } from './purchasing';
import { sharedReducers } from './shared';

// The organisation reducer is composed from per-tab handler maps. Each module
// owns one tab's actions; `shared` holds cross-cutting concerns. People and
// Activity share one filter slice (`filters`) — see researchers.js/workItems.js.
const REDUCER = {
  ...researchersReducers,
  ...workItemsReducers,
  ...clinicalTrialsReducers,
  ...tradeshowsReducers,
  ...purchasingReducers,
  ...sharedReducers,
};

const reducer = (state = defaultState, action) => {
  const handler = REDUCER[action.type];
  return handler ? handler(state, action) : state;
};

export default reducer;
